import { loadedAsyncState, Pair } from 'widgets-for-react'
import { List } from 'immutable'
import { Link } from 'react-router-dom'
import React = require('react')
import { ExtraImages } from '../../../../../utils/extra_images.mod'
import { ImageSize } from '../../../../../../cms/blocks/types.gen'
import { Map } from 'immutable'
import { PageKind } from '../../overview_page'
import { ImageContainer } from '../../../../../../cms/blocks/widgets/ImageContainer.gen'
import { TagTitle, TagValues } from '../../../../types.mod'
import { t } from 'i18next'
import { getLangFromUrl } from '../../../../../utils/history.mod'
import { getDetailPageHeaderImage } from '../../../../../templates/custom_page_header'

export type RenderOverviewBlocks = (page_kind: PageKind, selected_tags: Map<string, TagValues>, update_tags: (tags: Map<TagTitle, TagValues>, searchQuery: string) => void, items: List<ParsedOverviewDetailItem>, items_count: number) => JSX.Element

// ----- Articles/Resources
export type ParsedOverviewDetailItem = {
  Title: string
  Tags: string[]
  Description: string
  Link: Link
  Image: Map<ImageSize<ExtraImages>, string>
  ImageAltText?: string
  get_default_data_src: () => ImageSize<ExtraImages>
  get_default_data_srcset: () => Pair<ImageSize<ExtraImages>, string>[]
  Author?: string
  ReadingTime?: number
  CreationDate?: string
  meta?: string[]
}

export const renderArticleBlocks: RenderOverviewBlocks = (page_kind: PageKind, _, __, items: List<ParsedOverviewDetailItem>) => {
  return (
    <section className="block block--grid grid--actueel grid--link grid--header container--m gutter--m inview">
      <div className="block__inner">
        <div className="block__content">
          <ul className="block__list grid">
            {items.count() > 0 ? (
              items.map((item, index) => {
                if (item.Title) {
                  return renderArticleBlock(item, 'resource-item-' + index.toString())
                }
              })

            ) : (
              <p>Geen resultaten gevonden.</p>
            )}
          </ul>
        </div>
      </div>
    </section>
  )
}

export const renderArticleBlock = (item: ParsedOverviewDetailItem, key: string): JSX.Element => {
  return (
    <li key={key} className="grid__item">
      <article className="grid__article">
        <a className="grid__inner grid__link" href={item.Link.url}>
          <div className="grid__visual container fit-object">
            {item.Image && item.Image.count() > 0 ? (
              ImageContainer(
                loadedAsyncState(item.Image),
                "medium",
                "grid__image lazyload",
                item.ImageAltText,
                item.get_default_data_src,
                item.get_default_data_srcset
              ).run(_ => { })
            ) : (
              <img src="https://via.placeholder.com/350/" className="grid__image lazyload" alt="" />
            )
            }
          </div>

          <div className="grid__content">
            <header className="grid__header">
              {(item.Tags.concat(item.meta || []) || []).map((t, i) => <span key={i} className="grid__label text--xs">{t}</span>)}
              <div className="link--arrowed">
                <svg className="link__icon" aria-hidden="true" width="20px" height="20px"><use xlinkHref="#icon--arrow-right"></use></svg>
                <h3 className="grid__title title--s">{item.Title || ""}</h3>
              </div>
            </header>
            <p className="grid__intro text--s" dangerouslySetInnerHTML={{ __html: item.Description }} />
          </div>
          {/* <div>{item.meta && item.meta.map(meta => (<span>{meta}</span>))}</div>
          <div>{item.Description && <div dangerouslySetInnerHTML={{ __html: item.Description }} />}</div> */}
        </a>
      </article>
    </li>
  )
}

// ----- Cases

export const renderCaseBlock = (item: ParsedOverviewDetailItem, key: string): JSX.Element => {
  return (
    <li key={key} className="block__list-item item">
      <article className="grid__article">
        <div className="grid__content">
          {item.Tags && item.Tags.length > 0 && (
            <div className="grid__tags tags">
              {item.Tags.map((node, index) => {
                if (node.length > 0) {
                  return (
                    <span key={'case_tag_label_' + index} className="grid__tag tag">
                      {node}
                    </span>
                  )
                }
              })}
            </div>
          )}
          {((item.Title && item.Title.length > 0) || (item.Description && item.Description.length > 0)) && (
            <header className="grid__header">
              {item.Title && item.Title.length > 0 && <h3 className="grid__title title--s">{item.Title}</h3>}
              {item.Description && item.Description.length > 0 && <p className="grid__copy">{item.Description}</p>}
            </header>
          )}
          {item.Link && item.Link.url.length > 0 && (
            <footer className="grid__footer">
              <Link className="clickable" to={item.Link.url}>
                Bekijk case
              </Link>
            </footer>
          )}
        </div>
        {item.Image &&
          <div className="grid__visual">
            {ImageContainer(
              loadedAsyncState(item.Image),
              "medium",
              "grid__image lazyload",
              item.ImageAltText,
              item.get_default_data_src,
              item.get_default_data_srcset
            ).run(_ => { })}
          </div>
        }
      </article>
    </li>
  )
}


export const renderCasesBlocks: RenderOverviewBlocks = (page_kind: PageKind, _, __, items: List<ParsedOverviewDetailItem>) => {
  return (
    <section className="block block--links block--cases block--has-image container container--m grid--block">
      <div className="block__inner">
        {items.count() > 0 ? (
          <ul className="block__list">
            {items.map((item, index) => {
              if (item.Title) {
                return renderCaseBlock(item, 'Case_Item_' + index.toString())
              }
            })}
          </ul>
        ) : (
          <div> Geen resultaten </div>
        )}
      </div>
    </section>
  )
}

// ----- Vacancies

// export const renderVacatureBlock = (item: ParsedOverviewDetailItem, key: string): JSX.Element => {

//   let description = item?.Description
//   return (
//     <>
//       {item.Link && item.Link.url.length > 0 && (
//         <li key={key} className="block__list-item item">
//           <Link className="item__link" to={item.Link.url}>
//             {item.Tags && item.Tags.length > 0 && (
//               <ul className="tags">
//                 {item.Tags.map((tag, index) => {
//                   return (
//                     <li key={'vacancy_tag_label_' + index} className="item__label tag">
//                       {tag}
//                     </li>
//                   )
//                 })}
//               </ul>
//             )}
//             {item.Title && item.Title.length && <span className="item__title title--xs">{item.Title}</span>}
//             {description && description.length && <p className="item__text text--l">{description}</p>}
//             <span className="item__fauxlink clickable clickable--arrow">Bekijk vacatures</span>
//           </Link>
//         </li>
//       )}
//     </>
//   )
// }

// export const renderVacaturesBlocks: RenderOverviewBlocks = (page_kind: PageKind, _, __, items: List<ParsedOverviewDetailItem>) => {
//   return (
//     <section className="block block--links container container--m grid--block">
//       <div className="block__inner">
//         <div className="block__content">
//           {items.count() > 0 ? (
//             <ul className="block__list grid">
//               {items.map((item, index) => {
//                 if (item.Title) {
//                   return renderVacatureBlock(item, 'vacancy_item_+_' + index)
//                 }
//               })}
//             </ul>
//           ) : (
//             <div> Geen vacatures </div>
//           )}
//         </div>
//       </div>
//     </section>
//   )
// }

// Jobs


export const renderJobBlocks: RenderOverviewBlocks = (page_kind: PageKind, selected_tags, update_tags, items: List<ParsedOverviewDetailItem>, items_count: number) => {
  return (
    <section className="vacancies">

      <div className='vacancies__inner container container--m grid--gutter'>
        <header className="vacancies__header">
          <h2 className="vacancies__title title--s"> {items_count} {t("search:jobs_found")}</h2>
        </header>

        <div className="tags">
          <ul className="tags__list">
            {selected_tags.map(
              (values, key) => values.map(y =>
                <li className="tags__item">
                  <button className="tag" onClick={_ => update_tags(selected_tags.set(key, values.filter(value1 => value1 != y)), undefined)}>
                    <span className="tag__copy">
                      {
                        key == "vacancyCountry"
                          ? t(`search:tag_countryname:${y.replace("&", "_").replace(",", "_").replace("-", "_").split(/\s/).join('').toLowerCase()}`)
                          : key == "vacancyContract"
                            ? t(`search:tag_${y.replace("&", "_").replace(",", "_").replace("-", "_").split(/\s/).join('').toLowerCase()}`)
                            : key == "vacancyDepartment" ?
                              t(`search:tag_${getDetailPageHeaderImage(y).replace("&", "_").replace(",", "_").replace("-", "_").split(/\s/).join('').toLowerCase()}`)
                              : (y)
                      }
                    </span>
                    <svg className="tag__remove" aria-hidden="true" width="12px" height="12px"><use xlinkHref="#icon--cross" /></svg>
                  </button>
                </li>
              )).valueSeq().flatMap(x => x)}
          </ul>
        </div>
        {items.count() > 0 ? (
          <ul className="vacancies__list">
            {items.map((item, index) => {
              if (item.Title) {
                return renderJobBlock(item, 'resource-item-' + index.toString())
              }
            })}
          </ul>
        ) : (
          <div className="text--styled">
            <p> {t('search:no_results')}</p>
          </div>
        )}
      </div>
    </section>
  )
}

export const renderJobBlock = (item: ParsedOverviewDetailItem, key: string): JSX.Element => {
  let description = item?.Description?.replace(/style="font-size:8.5pt;font-family:&quot;Arial&quot;,sans-serif;\ncolor:black;background:white"/g, '')
  return (
    <li className="vacancy">
      <article className="vacancy__inner">
        <a href={`/${getLangFromUrl()}${item.Link.url}`} className="vacancy__link">
          <header className="vacancy__header">
            <h3 className="vacancy__title title--xs">{item.Title}</h3>
            {/* {description && <p className="vacancy__intro" dangerouslySetInnerHTML={{ __html: description }} />} */}
            <span className="vacancy__icon" />
          </header>

          <ul className="info__list">
            {JobInfoItem(item.Tags[0], 'pin', 24, 16)}
            {JobInfoItem(t(`search:tag_${item.Tags[1].replace("&", "_").replace(",", "_").replace("-", "_").split(/\s/).join('').toLowerCase()}`)
              , 'clock', 24, 22)}
            {JobInfoItem(t(`search:tag_${getDetailPageHeaderImage(item.Tags[2]).replace("&", "_").replace(",", "_").replace("-", "_").split(/\s/).join('').toLowerCase()}`)
              , 'department', 22, 22)}
          </ul>
          <span className="vacancy__faux-link">
            <svg className="vacancy__icon" aria-hidden="true" height="16" width="24">
              <use xlinkHref="#icon--arrow" />
            </svg>
            <span className="vacancy__label">{t("Vacancy:view_job_opening")}</span>
          </span>
        </a>
      </article>
    </li>
  )
}

export const JobInfoItem = (title: string, icon: string, height: number, width: number) => {
  if (title == "" || title == undefined) return
  return (
    <li className="info__item">
      <span>{title}</span>
      <svg className="info__icon" aria-hidden="true" height={height} width={width}>
        <use xlinkHref={`#icon--${icon}`} />
      </svg>
    </li>
  )
}